


















import Vue from 'vue';
export default Vue.extend({
    props: {
        value: {
            validator(obj) {
                return obj === null || obj instanceof Number;
            },
            required: true
        },
        cssClass: {
            type: String,
            required: false,
        },
        id: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            selected: this.value
        };
    },
    watch: {
        selected(selected: string) {
            this.$emit('input', selected);
        },
        value(value: number) {
            this.selected = value;
        },
    }
});
